"use client";

export default function Hero() {
  return null;
}